const NumbersFormattingMixin = {
  methods: {
    numberFormatting(num = 0) {
      /* eslint-disable */
      let parts = num.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      return parts.join(".");
      /* eslint-enable */
    },
    dateDifferenceInDays(startDate, endDate) {
      /* eslint-disable */
      console.log(startDate);
      console.log(endDate);
      const utc1 = Date.UTC(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
      const utc2 = Date.UTC(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());
      console.log(utc1);
      console.log(utc2);
      return Math.floor((utc2 - utc1) / (1000 * 60 * 60 * 24));
      /* eslint-enable */
    },
  },
};

export default NumbersFormattingMixin;



// WEBPACK FOOTER //
// ./src/common/mixins/numbersFormatting.js